export default __webpack_public_path__ + "static/media/School Hall.25ff3535.jpg";